import { parseStatus, splitTags } from './bulkUpdateColumns';

// Checks the values in each row against what exists in the environment, without the server.
// `tagNames` and `rings` ({ name, isActive }) are the environment's tags and deployment rings.
// Returns { rowNumber, idRef, errors } for every row that has a problem.
const preValidateRows = (rows, { tagNames, rings }) => {
  const knownTags = new Set(tagNames.map(name => name.trim().toLowerCase()));
  const ringsByName = new Map(rings.map(ring => [ring.name.trim().toLowerCase(), ring]));

  const rowsById = new Map();
  rows.forEach(row => {
    const list = rowsById.get(row.uniqueExternalId) || [];
    list.push(row);
    rowsById.set(row.uniqueExternalId, list);
  });

  return rows.flatMap(row => {
    const errors = [];

    if (!row.uniqueExternalId) {
      errors.push('Unique External Id is required');
    } else if (rowsById.get(row.uniqueExternalId).length > 1) {
      errors.push('Duplicate Unique External Id found in upload file');
    }

    if (row.deviceStatus && !parseStatus(row.deviceStatus)) {
      errors.push(
        `Device Status '${row.deviceStatus}' is not valid (use Approved, Revoked, Archived or Unknown)`,
      );
    }

    if (row.deploymentRingName) {
      const ring = ringsByName.get(row.deploymentRingName.toLowerCase());
      if (!ring) {
        errors.push(`Deployment Ring '${row.deploymentRingName}' does not exist`);
      } else if (!ring.isActive) {
        errors.push(`Deployment Ring '${row.deploymentRingName}' is not active`);
      }
    }

    const addTags = splitTags(row.addTags);
    const removeTags = splitTags(row.removeTags);
    const missingTags = [...addTags, ...removeTags].filter(
      name => !knownTags.has(name.toLowerCase()),
    );
    if (missingTags.length > 0) {
      errors.push(`Tag(s) do not exist: ${[...new Set(missingTags)].join(', ')}`);
    }
    const removedAndAdded = addTags.filter(name =>
      removeTags.some(other => other.toLowerCase() === name.toLowerCase()),
    );
    if (removedAndAdded.length > 0) {
      errors.push(`Tag(s) are in both Add Tags and Remove Tags: ${removedAndAdded.join(', ')}`);
    }

    return errors.length > 0
      ? [
          {
            rowNumber: row._rowNumber,
            idRef: row.uniqueExternalId || `row ${row._rowNumber}`,
            errors,
          },
        ]
      : [];
  });
};

export default preValidateRows;
